/** Janela em que um segundo aviso da mesma versão não recarrega de novo. */
export const APP_UPDATE_SUPPRESS_MS = 15_000

export const APP_UPDATE_RELOAD_KEY = 'crm-sw-reload'

export function planAppUpdateReload(input: {
  hadController: boolean
  updateReady: boolean
  markedAt: number | null
  now: number
}): { reload: boolean; markedAt: number | null } {
  const suppressed =
    input.markedAt !== null && input.now - input.markedAt < APP_UPDATE_SUPPRESS_MS
  if (suppressed) return { reload: false, markedAt: input.markedAt }
  if (!input.hadController || !input.updateReady) return { reload: false, markedAt: null }
  return { reload: true, markedAt: input.now }
}
